import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useUserSuperEmpresa } from "../Context/AuthContext";
import "../Css/LayoutSistema.css";
import Logo from "../Image/log-blanco.png";
import { BiGridAlt } from "react-icons/bi";
import { LuLogOut } from "react-icons/lu";
import HeaderPagina from "./HeaderPagina";
import { FaClinicMedical } from "react-icons/fa";
import { BsHouseFill } from "react-icons/bs";
import { FaUserMd } from "react-icons/fa";
import { FaUsersCog } from "react-icons/fa";
import { MdAddBusiness } from "react-icons/md";
import { FaUser } from "react-icons/fa6";
import { BsCardChecklist } from "react-icons/bs";
import { FaRegAddressCard } from "react-icons/fa";
import { MdOutlineLocalHospital } from "react-icons/md";
import { FaHandHoldingUsd } from "react-icons/fa";
import { BsTag } from "react-icons/bs";
import { GrSans } from "react-icons/gr";
import { BsFileBarGraph } from "react-icons/bs";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { FaHeartbeat } from "react-icons/fa";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { FaHouseUser } from "react-icons/fa6";

const LayoutSistema = () => {
  const { Usuario, logout } = useUserSuperEmpresa();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [activeSubMenuView, setActiveSubMenuView] = useState(null); 

  const roleId = Usuario?.id;


  const menuItems = [
    { name: "Dashboard", icon: <BiGridAlt />, path: "/inicio" },
    { name: "Perfil", icon: < FaUser />, path: "/perfil" },
    { name: "Gestión Usuarios", icon: <FaUsersCog />, path: "/Usuarios" },
    { name: "Centros Clinicos", icon: <MdAddBusiness />, path: "/centros/clinicos" },
    { name: "Equipo clinico", icon: <FaUserMd />, path: "/Equipo/clinico" },
      { name: "Previsiones", icon: <FaHeartbeat />, path: "/previsiones" },
    {
      name: "CBO",
      icon: <FaClinicMedical  />,
      subMenu: [
        { name: "Egresos", icon:  <BsTag />, path: "/CBO/egresos" },
        { name: "Ingresos", icon: <GrSans />, path: "/CBO/incomes" },
        { name: "Flujo de Ingresos", icon:  <BsFileBarGraph />, path: "/CBO/flujo-ingresos" },
        { name: "Ingresos de Pacientes", icon: <BsCardChecklist />, path: "/CBO/informe/ingresos" },
        { name: "Reportes SAP", icon: <MdOutlineLibraryBooks/>, path: "/CBO/SAP" },
        { name: "Prestación de servicios", icon: <MdOutlineLocalHospital />, path: "/CBO/prestacion/servicio" },
        { name: "Cobros y Devengos", icon: <FaHandHoldingUsd />, path: "/CBO/cobros-devengos" },
      ],
    },
    {
      name: "RME",  
      icon: < BsHouseFill/>,
      subMenu: [
        { name: "Egresos", icon: <BsTag />, path: "/RME/egresos" },
        { name: "Ingresos", icon: <GrSans/>, path: "/RME/incomes" },
        { name: "Flujo de caja", icon:  <BsFileBarGraph />, path: "/RME/flujocaja" },
        { name: "Estado de resultado", icon:  <FaMoneyBillTrendUp />, path: "/RME/estadoresultado" },
        { name: "Remuneración", icon: <FaRegAddressCard />, path: "/RME/remuneracion" },
        { name: "Proveedores", icon: <FaUsersCog /> , path: "/RME/proveedores" },
        
      ],
    },
   {
      name: "INMOB",  
      icon: <  FaHouseUser/>,
      subMenu: [
        { name: "Inicio INMOB", icon:  <BiGridAlt />, path: "/INMOB/inicio" },
        
        
      ],
    },  
   
  ];
  
  const menuPermitidoRol2 = ["Dashboard", "Perfil"];
const menuPermitidoRol3 = ["Dashboard", "Perfil"];


const menuFiltrado = menuItems.filter(item => {
  if (roleId === 2) {
    return menuPermitidoRol2.includes(item.name);
  }

  if (roleId === 3) {
    return menuPermitidoRol3.includes(item.name);
  }

  // otros roles (admin, superadmin, etc.)
  return true;
});



  const getPageTitle = () => {
  // Busca en el nivel principal
  const mainItem = menuItems.find(item => item.path === location.pathname);
  if (mainItem) return mainItem.name;

  // Busca en los submenús
  for (const item of menuItems) {
    if (item.subMenu) {
      const sub = item.subMenu.find(subItem => subItem.path === location.pathname);
      if (sub) return sub.name;
    }
  }

  return ""; // por defecto vacío si no encuentra
};


  const openSubMenuView = (name) => {
  setActiveSubMenuView(name);
};
const goBackToMainMenu = () => {
  setActiveSubMenuView(null);
};

  return (
    <div className="layout-container">
      <aside className={`sidebar ${expanded ? "expanded" : ""}`}>
        <div className="header-navbar">
          <div className="logo">
            <img src={Logo} alt="alemana activa" />
          </div>

          <button
            className="expand-btn-circle"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? <IoIosArrowBack /> : <IoIosArrowForward />}
          </button>
        </div>

          <ul className="menu">
           {menuFiltrado.map((item) => {
  const isMenuActive = location.pathname === item.path;

  // Si hay un submenú activo, mostrar solo el correspondiente
  if (activeSubMenuView && activeSubMenuView !== item.name) return null;

  return (
    <li key={item.name} className={`menu-item ${isMenuActive ? "active" : ""}`}>
      {!activeSubMenuView ? (
        // Menú principal
        <a href={item.path}>
        <div
          className="menu-item-header"
          onClick={() => item.subMenu ? openSubMenuView(item.name) : null}
        >
          <span className={`icon ${isMenuActive ? "active-icon" : ""}`}>{item.icon}</span>
          {expanded ? <span className={`name ${isMenuActive ? "active-name" : ""}`}>{item.name}</span> : <span className="tooltip">{item.name}</span>}
          {item.subMenu && expanded && <span className={`submenu-icon`}></span>}
        </div>
        </a>
      ) : (
        // Submenú solo para el item activo
        <>
          <div className="menu-item-header" onClick={goBackToMainMenu}>
            <IoIosArrowBack />
            {expanded && <span className="name">Volver</span>}
          </div>
          <ul className="submenu open">
            {item.subMenu.map(sub => {
              const isSubActive = location.pathname === sub.path;
              return (
                <li key={sub.name}>
                  <a href={sub.path} className={`submenu-item-link ${isSubActive ? "active" : ""}`}>
                    <span className="icon">{sub.icon}</span>
                    {expanded ? <span className="name">{sub.name}</span> : <span className="tooltip">{sub.name}</span>}
                  </a>
                </li>
              );
            })}
          </ul>
        </>
      )}
    </li>
  );
})}

          </ul>

        <div className="user-info">


    <button onClick={logout} className="logout-btn">
      <span className="icon"><LuLogOut /></span>
      {expanded ? <span className="name">Cerrar sesión</span> : <span className="tooltip">Cerrar sesión</span>}
    </button>
  </div>
        </aside>

        <main className="main-content">
            <HeaderPagina titulo={getPageTitle()} />
          <Outlet />
        </main>
      </div>
    );
};

export default LayoutSistema;